import { Practitioner } from "@medplum/fhirtypes";

export interface CareTeamParticipantSettings {
  primary: boolean;
  autoSubscribeToMessages: boolean;
  allowClientToMessage: boolean;
  status: CareTeamStatus;
}

export interface CareTeamMember extends CareTeamParticipantSettings {
  practitioner: Practitioner;
  remove?: boolean;
}

export interface CareTeamRow {
  id: string;
  members: string;
  client: string;
  status: string | undefined;
}

export enum SearchOptions {
  Client = "client",
  Provider = "provider",
}

export enum TeamsDrawerType {
  Filter = "filter",
  NewCareTeam = "new-care-team",
  NewTeamMember = "new-team-member",
  ManageCareTeam = "manage-care-team",
  ManageTeamMember = "manage-team-member",
}

export enum CareTeamStatus {
  Active = "active",
  Inactive = "inactive",
  Removed = "removed",
}

export const CareTeamStatusLabel = {
  [CareTeamStatus.Active]: "Active",
  [CareTeamStatus.Inactive]: "Inactive",
  [CareTeamStatus.Removed]: "Removed",
};
